export default "__VITE_ASSET__BaOjpecC__"